// Copyright (c) Microsoft Corporation. All rights reserved.

import { RouteComponentProps, withRouter } from "react-router-dom";

import { AuthenticationResult } from "@azure/msal-browser";
import Constants from "../misc/WegoConstants";
import React from "react";
import WegoAuth from "./WegoAuth";
import WegoConfiguration from "../WegoConfiguration";

interface WegoBrowserRedirectProps extends RouteComponentProps {
    wegoConfiguration: WegoConfiguration;
}

type WegoBrowserRedirectState = {
}

/*
** This service is ONLY used to support development scenarios in a naked browser session.
** When running outside Teams, we can"t rely on their SSO.  So we need to support our own.
*/
class WegoBrowserRedirect extends React.Component<WegoBrowserRedirectProps, WegoBrowserRedirectState> {
    authProvider: WegoAuth;

    constructor(props: WegoBrowserRedirectProps) {
        super(props);
        this.authProvider = new WegoAuth(false, props.wegoConfiguration);
    }

    componentDidMount() {
        const msalInstance = this.authProvider.msalObject!

        // Handle the redirect flows
        msalInstance.handleRedirectPromise().then((tokenResponse: AuthenticationResult | null) => {
            if (tokenResponse) {
                let resumeUrl = localStorage.getItem(Constants.Auth.UrlAfterRedirectKey);
                this.props.history.push(resumeUrl!);
            }
        }).catch((error) => {
            // Handle redirect error
        });
    }

    render() {
        return <></>;
    }
}

export default withRouter(WegoBrowserRedirect);